import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets';
import MainAccount from 'types/MainAccount';

const patchMainAccount = async (body: Partial<MainAccount>) => {
  try {
    await API.patch(
      apiName,
      `${apiBasePath}/mainaccounts/profile`,
      {
        body,
      },
      true,
      undefined,
      {
        tags: {
          section: SECTIONS.ACCOUNT,
          domain: DOMAINS.ACCOUNT,
          importance: IMPORTANCE.MEDIUM,
        },
        context: {
          mainAccountId: body.id,
        },
      },
    );
  } catch (error) {
    throw new Error('Your request could not be completed. Please try again');
  }
};

const useUpdateMainAccount = () => {
  const queryClient = useQueryClient();
  const mainAccountMutation = useMutation({
    mutationFn: ({ body }: { body: Partial<MainAccount> }) => {
      return patchMainAccount(body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mainaccount'] });
    },
  });
  return mainAccountMutation;
};

export default useUpdateMainAccount;
